import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=d6fd2492&scoped=true&"
import script from "./Journal.vue?vue&type=script&lang=js&"
export * from "./Journal.vue?vue&type=script&lang=js&"
import style0 from "./Journal.vue?vue&type=style&index=0&id=d6fd2492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fd2492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6fd2492')) {
      api.createRecord('d6fd2492', component.options)
    } else {
      api.reload('d6fd2492', component.options)
    }
    module.hot.accept("./Journal.vue?vue&type=template&id=d6fd2492&scoped=true&", function () {
      api.rerender('d6fd2492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Journal.vue"
export default component.exports